import { makeStyles } from '@material-ui/styles'

export default makeStyles((theme) => ({
  topic: {
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
}))
